import * as React from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { NoFlightsFoundMessaging } from '.';
import { FailedRequestMessaging, NoApiResponse } from 'components/shared/error-messages';
import { useStores } from 'utility/hooks';

export const ErrorListings = observer(() => {
  const { errorStore, analytics } = useStores();
  const { clientFetchFailure, noListingMessaging, failedRequestMessaging } = errorStore;

  useEffect(() => {
    if (
      clientFetchFailure ||
      (noListingMessaging && noListingMessaging.__typename !== 'FlightsNoFlightsFoundWithFilterMessaging')
    ) {
      analytics.markPageUsable();
    }
  }, [clientFetchFailure, noListingMessaging, analytics]);

  return (
    <>
      {errorStore.shouldRenderNFFMessage && <NoFlightsFoundMessaging noListingMessaging={noListingMessaging} />}
      {errorStore.shouldRenderFailedRequestError && (
        <FailedRequestMessaging flightsActionableErrorMessaging={failedRequestMessaging} />
      )}
      {errorStore.shouldRenderNoApiResponseError && <NoApiResponse />}
    </>
  );
});
